import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import AdminPage from 'modules/restaurant/admin/AdminPage';

export default function DashRestaurantAdmin() {
    return (
        <DashEstablishmentContainer title='Administração'>
            <AdminPage />
        </DashEstablishmentContainer>
    );
}
